
import { FX, Season } from "@/models/GameType";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DeleteBox from "../../Base/DeleteBox.vue";
import BaseTable from "../../Base/BaseTable.vue";
import { forIn, isEqual, cloneDeep } from "lodash";

@Component({
  components: {
    BaseTable,
    DeleteBox,
  },
})
class GameTypeFX extends Vue {
  @Prop({ default: null }) readonly seasonData!: Season;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  showDetails = false;
  showSavePanel = false;
  seasonDataObject = {} as Season;
  fxSlug = "";

  get getTableData(): FX[] {
    const fxArray: FX[] = [];
    forIn(this.seasonData.fx, (val: FX) => {
      fxArray.push(val);
    });
    return fxArray;
  }
  get getFxData(): FX {
    if (this.fxSlug !== "") {
      if (this.seasonData.fx[this.fxSlug] === undefined) {
        this.showDetails = false;
        return {} as FX;
      }
      return this.seasonData.fx[this.fxSlug];
    }
    return {} as FX;
  }
  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get showDeleteButton(): boolean {
    if (
      this.getFxData.slug === "clock_adjust" ||
      this.getFxData.slug === "wit_q" ||
      this.getFxData.slug === "informant" ||
      this.seasonData.inv_items[this.getFxData.slug] !== undefined
    ) {
      return false;
    }
    return true;
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  deleteItem(slug: string): void {
    delete this.seasonData.fx[slug];
    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete");
  }

  //Because the fxSlug might be different if the users swaps between games
  //We need to remove the show details so we don't keep an old screen up
  onRowSelected(row: FX): void {
    this.fxSlug = row.slug;
    if (this.seasonData.fx[this.fxSlug] === undefined) {
      this.showDetails = false;
    } else {
      this.showDetails = true;
    }
  }
  onValueChanged(): void {
    var data = {
      type: "FX",
      fx: this.getFxData,
      selectable: true,
    };

    if (!isEqual(this.seasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }

  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
}

export default GameTypeFX;
